import * as getters from "../../baseQuestion/searchableDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_high_school",
			option_source: {
				type: "country",
				filter: []
			},
			answer_externally_updated: true
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
